var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isMobileDispatchEnabled)?_c(_vm.dispatchComponent,{tag:"component",on:{"finished-dispatch":_vm.finishedDispatch,"quick-close":_vm.quickClose,"quick-close-finish-dispatch":_vm.quickCloseFinishDispatch}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }